/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.commentModule')
.directive('bulbCommentSide', ['$timeout','$window','BulbAuthService','BulbCommentService', bulbCommentSide]);

function bulbCommentSide($timeout, $window, BulbAuthService, BulbCommentService) {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/comment/comment-side.html',
    controller: 'CommentController as commentCtrl',
    link: function(scope, element) {

      scope.currentUser = BulbAuthService.currentUser;
      scope.commentService = BulbCommentService;

      // reposition
      var reposition = function() {
        var targetId = BulbCommentService.currentTargetId;
        var nodeType = BulbCommentService.nodeType;
        if (!targetId) {
          return;
        }
        var pos = BulbCommentService.getTargetElementPosition(targetId);
        if (pos) {
          jQuery('#bulb-comment-side-container-inner').css('top', pos.top);
        }
      };

      scope.$watch(function() {
        return BulbCommentService.currentTargetId;
      }, function() {
        reposition();
      });

      // focus textarea
      scope.$watch(function() {
        return BulbCommentService.currentTargetId + ' ' + BulbCommentService.activeCommentIdx;
      }, function() {
        $timeout(function() {
          var textArea = jQuery(element).find('.comment-large').find('textarea:visible');
          if (textArea) {
            textArea.focus();
          }
        });
      });

      element.on('click', function(event){
        event.stopPropagation();
      });

      scope.isActive = function(idx) {
        return BulbCommentService.activeCommentIdx === idx;
      };

      var resizeHandler = function(){
        if (BulbCommentService.isSideCommentEnabled()) {
          element.show();
        } else {
          element.hide();
        }
      };

      $timeout(function(){
        reposition();
        if (BulbCommentService.currentMediumEditor) {
          BulbCommentService.currentMediumEditor.subscribe('editableInput', reposition);
        }
        resizeHandler();
      });

      var window = jQuery($window);
      window.on('resize', resizeHandler);

      scope.$on('$destroy', function() {
        window.off('resize', resizeHandler);
      });
    }
  };
}
